module.exports = __webpack_public_path__ + "img/medical_bottom.4003e82e.jpg";